import { Stack, Container, useMediaQuery, useTheme } from "@mui/material";
import { Text } from "./Text";
import { HashLink } from "react-router-hash-link";

type LinkObj = {
  title: string;
  children: {
    text: string;
    href: string;
  }[];
};

const FooterItem = ({ link }: { link: LinkObj }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack>
      <Text color="#fff" fontWeight={500}>
        {link.title}
      </Text>
      <Stack marginTop={isMobile ? 1 : 2}>
        {link.children.map((child, index) => (
          <HashLink smooth to={child.href} key={index}>
            <Text color="#fff" lineHeight={2}>
              - {child.text}
            </Text>
          </HashLink>
        ))}
      </Stack>
    </Stack>
  );
};

export const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const links: LinkObj[] = [
    {
      title: "真菌について",
      children: [
        {
          text: "真菌とは",
          href: "/fungi#1",
        },
        {
          text: "ゲノム編集",
          href: "/fungi#2",
        },
        {
          text: "産業的活用",
          href: "/fungi#3",
        },
        {
          text: "当社ターゲット",
          href: "/fungi#4",
        },
      ],
    },
    {
      title: "技術紹介",
      children: [
        {
          text: "細胞内で自律的に複製可能なベクター",
          href: "/technology#1",
        },
        {
          text: "純国産のCRISPRフリーゲノム編集ツール",
          href: "technology#2",
        },
        {
          text: "微生物特化型のゲノム編集手法",
          href: "technology#3",
        },
        {
          text: "無性的なゲノム交雑の促進",
          href: "technology#4",
        },
      ],
    },
  ];

  return (
    <Stack
      component="footer"
      paddingTop={isMobile ? 3 : 7.5}
      paddingBottom={2.8}
      sx={{ background: "#006400" }}
    >
      <Container
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          justifyContent="space-between"
          flexWrap="wrap"
          gap={isMobile ? 1 : 3}
          padding={isMobile ? 0 : "0 30px"}
        >
          <Stack direction={isMobile ? "column" : "row"} gap={isMobile ? 2 : 8}>
            {links.map((linkItem, index) => {
              return <FooterItem key={index} link={linkItem} />;
            })}
            <Stack>
              <Stack>
                <HashLink to="/service">
                  <Text color="#fff" fontWeight={500}>
                    製品サービス
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink to="/news">
                  <Text color="#fff" fontWeight={500} marginTop={1}>
                    ニュース
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink to="/company">
                  <Text color="#fff" fontWeight={500} marginTop={1}>
                    会社概要
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink to="/contact">
                  <Text color="#fff" fontWeight={500} marginTop={1}>
                    お問い合わせ
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink to="/privacy">
                  <Text color="#fff" fontWeight={500} marginTop={1}>
                    プライバシーポリシー
                  </Text>
                </HashLink>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            width={isMobile ? 120 : 222}
            margin={isMobile ? "20px auto 0" : 0}
          >
            <HashLink to="/">
              <img
                src="/images/footer-logo.png"
                alt=""
                style={{ width: "100%" }}
              />
            </HashLink>
          </Stack>
        </Stack>
        <Text
          color="#fff"
          fontSize={12}
          textAlign="center"
          marginTop={isMobile ? 4 : 9}
        >
          Copyright © Tokyo University of Science All Rights Reserved.
        </Text>
      </Container>
    </Stack>
  );
};
